export const DESIGN_PRESET_BORDER_STYLES = ['none', 'solid', 'dashed', 'dotted'] as const;
export type DesignPresetBorderStyle = (typeof DESIGN_PRESET_BORDER_STYLES)[number];
export type BorderSideIndex = 0 | 1 | 2 | 3;

export function parseDesignPresetBorderStyles(
	value: string
): [DesignPresetBorderStyle, DesignPresetBorderStyle, DesignPresetBorderStyle, DesignPresetBorderStyle] {
	const parts = value.trim().split(/\s+/);
	if (
		parts.length > 4 ||
		!parts.every((part): part is DesignPresetBorderStyle =>
			DESIGN_PRESET_BORDER_STYLES.some(style => style === part)
		)
	)
		throw new Error('Use none, solid, dashed or dotted for one to four border sides.');
	const top = parts[0];
	const right = parts[1] ?? top;
	return [top, right, parts[2] ?? top, parts[3] ?? right];
}

export function setDesignPresetBorderStyles(
	value: string | undefined,
	sides: readonly BorderSideIndex[],
	style: DesignPresetBorderStyle
): string {
	const next = parseDesignPresetBorderStyles(value ?? 'none');
	for (const side of sides) next[side] = style;
	const [top, right, bottom, left] = next;
	if (top === right && top === bottom && top === left) return top;
	if (top === bottom && right === left) return `${top} ${right}`;
	if (right === left) return `${top} ${right} ${bottom}`;
	return next.join(' ');
}
